// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import ProjectButton from "./ProjectButton.jsx";
import tippy from "../../common/tippy-control.js";

/**
 * @param {Object}   props
 * @param {function} props.onClickProject
 * @param {Array}    props.projects
 * @param {string}   props.selectedProjectUuid
 * @return {HTMLElement}
 */
const ProjectList = props => {
	// Prepare topic buttons for topic list
	const projectButtons = [];

	for (const project of props.projects) {
		projectButtons.push(<ProjectButton
			onClickProject={props.onClickProject}
			project={project}
			isSelected={project.uuid === props.selectedProjectUuid}
		/>);
	}

	// TODO: If there are no projects show a msg?

	const ul = <ul className="projects-list js-projects" lang="">
		{projectButtons}
	</ul>;

	// Add tooltips that only show if the text is overflowing
	tippy(ul.querySelectorAll("[data-tippy-content]"), {
		overflowingClass:      "project-text",
		placement:             "left",
		showOnlyIfOverflowing: true
	});

	return ul;
};

export default ProjectList;
